export const fetchEvents = resp => ({
  type: "FETCH_EVENTS",
  payload: resp
});
export const fetchEventIds = resp => ({
  type: "FETCH_EVENT_IDS",
  payload: resp
});



// WEBPACK FOOTER //
// ./src/actions/actions/event.js